/**
 * UpgradeGem use case: increase gem level in a tower slot.
 */

import { upgradeGemInSlot, MAX_GEM_LEVEL } from "../../domain/session.js";
import type { UpgradeGemError } from "../../domain/types.js";
import type { RenderPort } from "../ports.js";
import { sessionToView } from "../state-view.js";
import type { GemSlot } from "../types.js";

export interface UpgradeGemDeps {
  render: RenderPort;
  getSession(): import("../../domain/session.js").GameSession | null;
}

export function createUpgradeGem(deps: UpgradeGemDeps) {
  return function upgradeGem(slot: GemSlot): { ok: true } | UpgradeGemError {
    const session = deps.getSession();
    if (!session) return { code: "InvalidSlot" };

    const tower = session.towers.find((t) => t.id === slot.towerId);
    if (!tower) return { code: "InvalidSlot" };
    const gemSlot = tower.gemSlots[slot.slotIndex];
    if (!gemSlot?.gem) return { code: "InvalidSlot" };
    if (gemSlot.gem.level >= MAX_GEM_LEVEL) return { code: "AlreadyMaxLevel" };

    const ok = upgradeGemInSlot(session, slot.towerId, slot.slotIndex);
    if (!ok) return { code: "NotEnoughMana" };

    deps.render.update(sessionToView(session, "game"));
    return { ok: true };
  };
}
